<template>
    <div :class="classes">
        <div>
            <router-link
                to="/examine/entry"
                tag="div">
                <span class="dp fontsize18">审核台</span>
                <span class="dp sel-badge" v-html="reviewnum">99+</span>
            </router-link>
        </div>
    </div>
</template>
<script>
const prefix = "w-examine";

export default {
    props: {},
    data() {
        return {
            prefix,
            reviewnum: 0,
            adminuseraccess: "",
            firstId: []
        };
    },
    methods: {
        init() {
            this.getaccess();
            this.getaccess_list()
        },
        getaccess() {
            this.api
                .adminuseraccess({
                    access_token: localStorage.getItem("access_token"),
                })
                .then((da) => {
                    this.adminuseraccess = JSON.stringify(da);
                });
        },
        gettodoCount() {
            let access = JSON.parse(localStorage.getItem("access"));
            let mpd = this.getSsaa(access.top_banner);
            this.api
                .todoCount({
                    access_token: localStorage.getItem("access_token"),
                    signup: JSON.stringify(mpd.signup),
                    select: JSON.stringify(mpd.select),
                    photo_work: JSON.stringify(mpd.photo_work),
                    project_accept: JSON.stringify(mpd.project_accept),
                    work_launch: mpd.work_launch.length > 0,
                    work_shortlist: mpd.work_shortlist.length > 0,
                    work_hire: mpd.work_hire.length > 0,
                    contributor_apply: mpd.contributor_apply.length > 0,
                })
                .then((da) => {
                    this.doCount = da;
                    this.reviewnum = da.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getaccess_list() {
            this.api
                .access({
                    access_token: localStorage.getItem("access_token"),
                })
                .then((da) => {
                    let accessArry = da.data.top_banner;
                    for (var i = 0; i < accessArry.length; i++) {
                        if (accessArry[i].id == "11") {
                            var newArr = accessArry[i].child;
                            for (
                                let i2 = 0, n2 = newArr.length;
                                i2 < n2;
                                i2++
                            ) {
                                this.firstId.push(newArr[i2].id);
                            }
                            this.gettodoCount();
                        }
                    }
                });
        },
    },
    created() {
        this.init();
    },
    computed: {
        classes() {
            return [prefix];
        },
    },
};
</script>

<style lang="scss">
$prefixCls: w-examine;

.#{$prefixCls} {
    cursor: pointer;
    display: inline-block;
    .sel-badge{
        width: 38px;
        height: 24px;
        line-height: 24px;
        margin: 0 5px;
        text-align: center;
        border-radius: 24px;
        background: #33B3FF;
        color: white;
    }
}
</style>
